const prefixName = '@pld/Catalogs/';

export const SET_CATALOGS = `${prefixName}set_catalogs`;
export const SET_CATALOG_LOADING = `${prefixName}set_catalog_loading`;
export const SET_CATALOG_ERROR = `${prefixName}set_catalog_error`;
export const CLEAR_CATALOGS = `${prefixName}clear_catalogs`;
